import {getRequest} from './base';

const searchProduct = async (sku) => {
  return await getRequest(`/catalog/product/${sku}/`);
};

export {searchProduct};
